import { SimplePagination, Table } from '@dixa/lib-shared-habla';

import { useMessengers } from 'hooks/useMessengers';

type ListingFootProps = Pick<
  ReturnType<typeof useMessengers>,
  | 'hasNextPage'
  | 'hasPreviousPage'
  | 'nextPage'
  | 'previousPage'
  | 'asyncStatus'
>;

export function ListingFoot({
  hasNextPage,
  hasPreviousPage,
  nextPage,
  previousPage,
  asyncStatus,
}: ListingFootProps): JSX.Element | null {
  const hasFoot = hasNextPage || hasPreviousPage;

  if (!hasFoot) return null;

  return (
    <Table.Tfoot>
      <Table.Tr>
        <Table.Td>
          <SimplePagination
            previousButtonClick={previousPage}
            previousButtonDisabled={!hasPreviousPage}
            nextButtonClick={nextPage}
            nextButtonDisabled={!hasNextPage}
            loading={asyncStatus === 'loading'}
          />
        </Table.Td>
      </Table.Tr>
    </Table.Tfoot>
  );
}
